import { rei } from "@/services/api"

class NascimentoService {
  static storeNascimento (params) {
    return rei.post(`nascimentos`, { ...params }).then(res => res.data)
  }

  static storeGemeos (params) {
    return rei.post(`nascimento-gemeos`, {...params}).then(res => res.data)
  }

  static getNascimentoById (idNasc) {
    return rei.get(`nascimentos/${idNasc}`).then(res => res.data)
  }

  static updateNascimento (idNasc, params) {
    return rei.put(`nascimentos/${idNasc}`, { ...params }).then(res => res.data)
  }

  // Rascunhos feitos para uma única API com o MongoDB
  static storeNascimentoRasc (params) {
    return rei.post(`registros-rascunho`, { ...params }).then(res => res.data)
  }

  static updateNascimentoRasc (idNasc, params) {
    return rei.put(`registros-rascunho/${idNasc}`, { ...params }).then(res => res.data)
  }

  static getNascimentoRascById (idNasc) {
    return rei.get(`registros-rascunho/${idNasc}`).then(res => res.data)
  }

  static getNascimentoByMatricula (matricula) {
    return rei.get(`nascimento-by-matricula/${matricula}`).then(res => res.data)
  }
  
  static transporte (params) {
    return rei.post(`transporte-nascimento`, { ...params }).then(res => res.data)
  }
}

export default NascimentoService
